module.exports = __webpack_public_path__ + "img/a_sesamo.c5ff7701.svg";